

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';

import Image4 from "../../assets/images/icon-1.png";
import Image5 from "../../assets/images/icon-3.jpg";
import Image6 from "../../assets/images/icon-2.jpg";
import Image7 from "../../assets/images/icon-4.png";
import "../financially/Financially.css";

const features = [
  {
    image: Image4,
    title: "100% Equity with promoters",
    desc: "Gautam Solar is privately held, with 100% equity with its promoters to ensure a long term outlook for the company as it allows the company to adapt to the changing market conditions with quicker and more decisive action and allow a long-term planning and execution of strategic initiatives.",
    alt: true,
  },
  {
    image: Image5,
    title: "Profitable in Solar since last 25 years",
    desc: "Gautam Solar has been consistently profitable in the solar industry since the last 25 years, unlike a number of solar energy startups which have come into existence in just the past few years and are yet to reach profitability.",
    alt: false,
  },
  {
    image: Image6,
    title: "Bankable Company for Solar Modules",
    desc: "Gautam Solar is a bankable company for businesses looking to procure solar modules, as evidenced by the company's strong balance sheet. Additionally, the company has a provision for a warranty fund and cash to withstand warranty claims.",
    alt: false,
  },
  {
    image: Image7,
    title: "In Solar since 1998",
    desc: "Gautam Solar provides a 10-year product warranty and a 25-year performance warranty, backed by over 25 years of industry experience. It matches the typical lifetime of a Solar Plant in contrast to some less experienced companies, sourcing modules from China, which have faced bankruptcy or warranty issues.",
    alt: true,
  },
];

function Financially() {
  return (
    <section style={{ background: "#faf7f7", padding: "30px 0" }} className="border-top">
      <Container>
        <Row className="justify-content-center mb-4">
          <Col xs={12} md={10} className="text-center">
            <h2 className="financial-section-title text-black">
              <span style={{ color: "#a20000" }}>Financially</span> Strong
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          {features.map((feature, idx) => (
            <Col xs={12} key={idx}>
              <div className={`financial-feature-card${feature.alt ? " alt" : ""}`}>
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="financial-feature-img"
                />
                <div className="financial-feature-content">
                  <h3>{feature.title}</h3>
                  <p>{feature.desc}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default Financially;
